import { useVuex } from '@issue-detail/utils/useVuex';
import { computed, ref, Ref } from '@vue/composition-api';

import { IssueAssembleResponse } from '../Model/Issue';
import { ActionStore } from './action';

export const useThirdTools = (
  actionStore: ActionStore,
  issueAssemble: Ref<IssueAssembleResponse | null>
) => {
  const vuex = useVuex();

  const showGitlab = ref(false);
  const showGitHub = ref(false);
  const showCoding = ref(false);
  const showCodeUp = ref(false);
  const showFoxLab = ref(false);

  return {
    isZoomOpen: computed(
      () => vuex.state.features.features.zoom_integration_switch
    ),
    jenkinsStatus: computed(
      () => issueAssemble.value?.integrationIssueVO?.jenkinsStatusVO
    ),
    foxLabStatus: computed(
      () => issueAssemble.value?.integrationIssueVO?.foxLabStatusVo
    ),
    gitlabStatus: computed(
      () => issueAssemble.value?.integrationIssueVO?.gitLabStatusVo
    ),
    sentryStatus: computed(
      () => issueAssemble.value?.integrationIssueVO?.sentryStatusVo
    ),
    gitlabEnable: computed(
      () =>
        !!issueAssemble.value?.gitConfigVO?.find((i) => i.gitType === 0 && i.diffType === 0)
          ?.enabled
    ),
    gitHubEnable: computed(
      () =>
        !!issueAssemble.value?.gitConfigVO?.find((i) => i.gitType === 1)
          ?.enabled
    ),
    codingEnable: computed(
      () =>
        !!issueAssemble.value?.gitConfigVO?.find((i) => i.gitType === 2)
          ?.enabled
    ),
    codeUpEnable: computed(
      () => !!(issueAssemble.value?.gitConfigVO?.find(i => i.gitType === 3)?.enabled)
    ),
    foxLabEnable: computed(
      () => !!(issueAssemble.value?.gitConfigVO?.find(i => i.gitType === 0 && i.diffType === 1)?.enabled)
    ),
    foxLabCIEnable: computed(
      () => !!(issueAssemble.value?.gitConfigVO?.find(i => i.gitType === 0 && i.diffType === 1)?.ciCdEnabled)
    ),
    gitlabCIEnable: computed(
      () => !!(issueAssemble.value?.gitConfigVO?.find(i => i.gitType === 0 && i.diffType === 0)?.ciCdEnabled)
    ),
    showGitlab,
    showGitHub,
    showCoding,
    showCodeUp,
    showFoxLab
  };
};

export type ThirdToolsStore = ReturnType<typeof useThirdTools>;
